// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n\n/* Mixins */\n.yfh-page .nb-form .el-select,\n.yfh-page .nb-form .el-cascader {\n  width: 100%;\n}\n.yfh-page .nb-form .el-form-item__label {\n  font-weight: bold;\n  font-size: 12px;\n}\n.yfh-page .tip-box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 10px;\n}\n.yfh-page .tip-box .el-button {\n  margin-right: 20px;\n}\n.yfh-page .el-alert {\n  width: 400px;\n}", ""]);
// Exports
exports.locals = {
	"theme": "#30B08F",
	"menuBg": "#304156",
	"menuText": "#bfcbd9",
	"menuActiveText": "#409EFF"
};
module.exports = exports;
